export const type = {
  SAVE_LOCAL_DAILY_WORK_REPORT: "SAVE_LOCAL_DAILY_WORK_REPORT",
  REMOVE_SAVE_REPORT:"REMOVE_SAVE_REPORT"
}
